import { connect } from 'react-redux';
import SiswaBatalMasuk from '../../../../views/Finance/Spp/LaporanSPP/SiswaBatalMasuk.view';
import {  listPPDBCancel, listPPDBGeneralCancel, listPPDBF07Cancel, setNominal } from '../../../../states/thunks/academics.thunk';
import { getPeriodsOptions, getUsernameOptions, getUserGroups, getSchoolUnitsOptions, getYearsOfEducationsOptions } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}
function mapDispatchToProps(dispatch) {
  return {
      handleListPPDBCancel: (payload, goback) => dispatch(listPPDBCancel(payload, goback)),
      handleListPPDBGeneralCancel: (payload, goback) => dispatch(listPPDBGeneralCancel(payload, goback)),
      handleListPPDBF07Cancel: (payload, goback) => dispatch(listPPDBF07Cancel(payload, goback)),
      handleSetNominal: (payload, goback) => dispatch(setNominal(payload, goback)),
      getUsernameOptions: payload => dispatch(getUsernameOptions(payload)),
      getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
      getUserGroups: payload => dispatch(getUserGroups(payload)),
      getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
      getYearsOfEducationsOptions: payload => dispatch(getYearsOfEducationsOptions(payload)),
   
    };

}

export default connect(mapStateToProps, mapDispatchToProps)(SiswaBatalMasuk);
